// Signal emitted after any successful add/update/delete/batch so other
// components (or the section itself) can trigger a refetch.
export const LI_V2_REFRESH = "li-v2:refresh";

// Content -> Editor: open the rail form. Payload `{ investigation }` prefills
// an edit; `{}` resets to a blank add. The editor rail owns the form now
// (Figma 3041:11589) — the old centered modal is gone.
export const LI_V2_EDIT = "li-v2:edit";

// Content: open the "Digitise report" modal — the same one the card's
// "+ Add investigation" opens. The section owns that modal's state, so this is
// the way in from outside it: the mobile screen's pinned add button, which sits
// below the card rather than in it. Desktop never emits it.
export const LI_V2_DIGITISE = "li-v2:digitise";
